import config from 'Config';

import { STATE_INITIAL } from 'Store/commonActions';

import type { ProfileState } from './types';

const initialState: ProfileState = {
  account: {},
  allInGender: [],
  availableDescriptors: [],
  bouncerBypass: {},
  contactCards: {},
  consumableMerchandising: {},
  editAllInGenderLocalValues: {
    display_genders: [],
    display_sexual_orientations: [],
  },
  featureAccess: {},
  featureOrdering: {},
  likes: {},
  notifications: [],
  miscMerchandising: {},
  offerings: [],
  onboarding: {
    tutorials: [],
  },
  paywalls: [],
  plusControl: {},
  products: [],
  profileMeter: {
    percentAchieved: 0,
    incompleteComponents: [],
  },
  purchase: {
    purchases: [],
  },
  readReceipts: {},
  readReceiptsState: {
    enabled: false,
    status: STATE_INITIAL,
    matchId: '',
  },
  state: { status: STATE_INITIAL },
  subMerchandisingProductData: {},
  subMerchandisingPageData: {},
  superlikes: {},
  travel: {},
  tutorials: [],
  user: {
    _id: '',
    all_in_gender: [],
    has_redacted_enabled: false,
    display_genders: [],
    display_sexual_orientations: [],
    age_filter_max: config.discoverySettings.ageMax,
    age_filter_min: config.discoverySettings.ageMin,
    auto_expansion: {},
    distance_filter: config.discoverySettings.distanceMin,
    gender_filter: 0,
    gender: 0,
    interested_in: [],
    interested_in_genders: [],
    is_traveling: false,
    jobs: [],
    photos: [],
    pos_info: {},
    preference_filters: {},
    schools: [],
    sexual_orientations: [],
    social: {
      mutuals_opt_in: null,
    },
    user_prompts: {
      section_name: 'Prompts',
      max_prompts: 0,
      prompts: [],
    },
  },
  heightMeasureType: 'cm',
  hasUserViewedAllInScreensBefore: false,
};

export default initialState;
